import React from 'react';

import HintButton from 'components/HintButton';
import { appReactMemo } from 'hocs';

import Switch from '../Switch';
import { ISwitchProps } from '../Switch/styled';

import { Body, Container, Error, Label, LabelContainer } from './styled';

export interface ISwitchInputProps extends ISwitchProps {
  errorMessage?: string;
  hintText?: string;
  maxHintWidth?: number;
  showError?: boolean;
  size?: 'lg' | 'sm';
  withLabelGap?: boolean;
}

const SwitchInput = ({
  className,
  errorMessage,
  hintText,
  label,
  maxHintWidth,
  onChange,
  showError,
  size = 'sm',
  withLabelGap,
  ...rest
}: ISwitchInputProps) => {
  const renderLabel = () => {
    const content = typeof label === 'function' ? label() : label;

    return <Label>{content}</Label>;
  };

  return (
    <Container $size={size} $withLabelGap={withLabelGap} className={className}>
      <Body>
        <LabelContainer>
          {renderLabel()}
          {hintText && <HintButton maxHintWidth={maxHintWidth}>{hintText}</HintButton>}
        </LabelContainer>
        <Switch {...rest} onChange={onChange} />
      </Body>
      {showError && <Error>{errorMessage}</Error>}
    </Container>
  );
};

export default appReactMemo(SwitchInput);
